import React from 'react'

export function LegendText(text) {
  return text ? (<span className="legend-text">{text.text}</span>) : null
}
